import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-sm border border-gray-100 p-6 transition-all duration-300 ${hoverEffect ? 'hover:shadow-xl hover:-translate-y-1' : ''} ${className}`} {...props} data-id="element-492">
      {children}
    </div>;
}